module.exports = __webpack_public_path__ + "media/images/city_img/icon1-f6263bf8edb7ac6fbe8518913cc8c5b0.png";